module.exports = __webpack_public_path__ + "static/hlk-2afac64ab7e220c1bd93c9b8fc9b7f17.jpg";